var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"barrage-title-wrapper",style:(_vm.wrapperStyle)},[_c('div',{staticClass:"barrage-title-bg",style:(_vm.titleBgStyle)}),_c('span',{ref:"subTitleRef",class:_vm.titleClass},[_vm._v(" "+_vm._s(_vm.subTitle.content)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }